import { createRouter, createWebHistory } from 'vue-router'
import MainPage from '../components/MainPage.vue'
import TestPageView from '../components/TestPageView.vue'

const routes = [
  {
    path: '/',
    name: 'MainPage',
    component: MainPage
  },
  {
    path: '/test',
    name: 'TestPage',
    component: TestPageView
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router

